// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"70ee8dd7","422":"cfe1047f","777":"713d4a63"}[chunkId] + ".chunk.js";
};